// The webpack build will replace process.env.PUBLIC_URL with the actual URL
const PUBLIC_URL = process.env.PUBLIC_URL || '';

export function getAssetUrl(path) {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return PUBLIC_URL ? `${PUBLIC_URL}/${cleanPath}` : path;
} 